<template>
  <a-entity />
</template>

<script>
import Settings from '@/config/Settings'
import { webkit } from './Howler'

export default {
  name: 'Player',
  props: ['name', 'sprite'],
  data: () => ({
    id: null,
    maxVolume: Settings.volume ? 1 : 0
  }),
  watch: {
    isPlaying() {
      const id = this.$parent.id
      if(this.$parent.type == 'webkit') {
        this.isPlaying
        ? this.$music.play(id)
        : this.$music.pause(id)
      } else {
        if(this.isPlaying) {
          this.$music.play(id)
          this.$music.fade(0, this.maxVolume, 1000, id)
        } else {
          this.$music.fade(this.maxVolume, 0, 1000, id)
          this.$music.once('fade', () => this.$music.pause(id), id)
        }
      }
    },
  },
  beforeDestroy() {
    if(this.sprite == 'FinBoucle')
      this.$parent.explorer.id = this.id

    if(this.$parent.type == 'webkit') return
    this.$music.fade(this.maxVolume, 0, 1000, this.id)
    this.$music.once('fade', () => {
      this.sprite == 'FinBoucle'
      ? this.$music.pause(this.id)
      : this.$music.stop(this.id)
    }, this.id)
  },
  created() {
    this.$store.commit('app/SET_PLAYING', true)
    this.$music = this.$parent.type == 'webkit' ? this.$parent.$musics['webkit'] : this.$parent.$musics[this.name]
    if(this.$parent.type == 'webkit') {
      const sprite = _.find(webkit[this.name], (m,k) => k == this.sprite)
      this.sprite == 'FinBoucle' && this.$parent.explorer.seek
      ? this.$music.seek(this.$parent.explorer.seek)
      : this.$music.seek(sprite[0] / 1000)
    } else {
      this.sprite == 'FinBoucle' && this.$parent.explorer.id
      ? this.id = this.$music.play(this.$parent.explorer.id)
      : this.id = this.$music.play(this.sprite)

      this.$parent.id = this.id
      this.$music.fade(0, this.maxVolume, 1000, this.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/music/Player.vue